/* analyticsDuck is DEPRECATED - Please use reaxl-analytics */

import hasDom from 'has-dom';
import { Duck } from '@atc/modular-redux';
import { waitUntil } from '@atc/wait-until';

//  consts for waitUntil timing settings
const WAITDELAY = 200;
const WAITTIMEOUT = 40000;

/*
* Simulate legacy birf dom tagging
*/
export function simulateDomTagging(birfData, customEventData) {
  // Create an element to house the data attributes
  const element = document.createElement('div');

  // Append the data simulation element to the DOM
  document.body.appendChild(element);

  // Create a simulated click event
  const simulatedEvent = new CustomEvent('click', {
    bubbles: true,
    cancelable: true,
    detail: customEventData
  });

  // Dispatch the simulatd event on the simulated element
  element.dispatchEvent(simulatedEvent);
}

/*
* Process state objects
*/
function processState(state) {
  // Handle Immutable maps being returned as state
  // The preferred method is using Iterable.isIterable but we don't want to
  // include the immutable library to just handle this.
  if (typeof state.toJS === 'function') {
    return state.toJS();
  }
  return state;
}
export function sendAnalyticsEvent(name, detail) {
  if (detail === void 0) {
    detail = {};
  }
  if (hasDom()) {
    const analyticsEvent = new CustomEvent(`analytics:${name}`, {
      detail
    });

    // Legacy window event for DTM
    window.dispatchEvent(analyticsEvent);
    window.document.dispatchEvent(analyticsEvent);
  }
}
export default function analyticsDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'analytics',
    storePath,
    initialState = {
      pageData: null
    },
    supportDomTagging = false
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    namespace,
    store,
    storePath,
    consts: {},
    types: ['SET_PAGE_DATA'],
    initialState,
    reducer: (state, action, _ref) => {
      let {
        types
      } = _ref;
      switch (action.type) {
        case types.SET_PAGE_DATA:
          {
            return {
              ...state,
              pageData: action.payload
            };
          }
        default:
          return state;
      }
    },
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        addDomEventTagging: () => async (dispatch, getState) => {
          if (hasDom()) {
            const handleAnalyticsEventClick = event => {
              // Send Analytics click event
              sendAnalyticsEvent('click', {
                isGeneric: true,
                originalEvent: event,
                state: processState(getState())
              });
            };
            // eslint-disable-next-line listeners/no-missing-remove-event-listener
            window.addEventListener('click', handleAnalyticsEventClick, false);
            const handleAnalyticsEventChange = event => {
              // Send Analytics change event
              sendAnalyticsEvent('change', {
                isGeneric: true,
                originalEvent: event,
                state: processState(getState())
              });
            };
            // eslint-disable-next-line listeners/no-missing-remove-event-listener
            window.addEventListener('change', handleAnalyticsEventChange, false);
          }
        },
        sendPageEvent: data => async (dispatch, getState) => {
          if (hasDom()) {
            // Send Analytics page event
            sendAnalyticsEvent('page', {
              ...data,
              state: processState(getState())
            });
            dispatch({
              type: types.SET_PAGE_DATA,
              payload: data.page && data.page.BIRF
            });
          }
        },
        sendEvent: (type, data) => async (dispatch, getState) => {
          if (hasDom()) {
            // Send Analytics click event
            sendAnalyticsEvent(type, {
              ...data,
              state: processState(getState())
            });
          }
        },
        sendClickEvent: function (event, data) {
          if (event === void 0) {
            event = {};
          }
          return async (dispatch, getState) => {
            if (event && typeof event.persist === 'function') {
              event.persist();
            }
            if (hasDom()) {
              const customEventData = {
                ...data,
                originalEvent: event,
                state: processState(getState())
              };

              // Send Analytics click event
              sendAnalyticsEvent('click', customEventData);
              if (supportDomTagging) {
                simulateDomTagging({
                  ...data
                }, customEventData);
              }
            }
          };
        },
        addImpression: () => () => {},
        sendImpression: impression => async (dispatch, getState) => {
          if (hasDom()) {
            // Send Analytics impression event
            sendAnalyticsEvent('impression', {
              ...impression,
              state: processState(getState())
            });
          }
        },
        sendImpressions: function (impressions, group) {
          if (impressions === void 0) {
            impressions = [];
          }
          return async (dispatch, getState) => {
            if (hasDom()) {
              // Send Analytics impressions event
              const readyForPixallImpression = () => !!window.Pixall;
              waitUntil(readyForPixallImpression, () => sendAnalyticsEvent('impressions', {
                impressions,
                group,
                state: processState(getState())
              }), WAITDELAY, WAITTIMEOUT);
            }
          };
        }
      };
    }
  });
}